import { createFileRoute } from "@tanstack/react-router";
import { Replay } from "../features/topo/Replay";

export const Route = createFileRoute("/w/$ws/c/$channel_/replay")({
  component: () => <Replay channelId={Route.useParams().channel} />,
});
